import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { DownloadStatusService } from './download-status.service';
import { ReportDelivery } from 'ldt-data-deliveries-api';

@Component({
    selector: 'app-download-status-container',
    template: `
    <app-download-status 
      *ngIf="activeDownload" 
      [download]="activeDownload">
    </app-download-status>
  `,
    standalone: false
})
export class DownloadStatusContainerComponent implements OnInit, OnDestroy {
  activeDownload: ReportDelivery | null = null;
  private subscription: Subscription;

  constructor(private downloadStatusService: DownloadStatusService) {}

  ngOnInit(): void {
    this.subscription = this.downloadStatusService.getActiveDownload().subscribe((download) => {
      this.activeDownload = download;
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
